module.exports = __webpack_public_path__ + "static/img/txt-3.717ce6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-3.png
// module id = Knbt
// module chunks = 0